import { gql } from "@apollo/client";

export const TAB_MANAGEMENT_REPORT = gql`
  query orders(
    $where: orders_bool_exp!
    $offset: Int!
    $limit: Int!
  ) {
    orders(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { transaction_time: desc }
    ) {
    id
    items
    subtotal
    tax
    tip
    status
    user_id
    created_at
    updated_at
    transaction_time
    reference_id
    discount
    location_id
    event_id
    digital_surcharge
    attendee_id
    vendor_id
    mx_ref_id
    android_device_id
    is_tab
    name
    nickname
    attendee {
      first_name
      last_name
      card_on_files(order_by: {created_at: desc}, where: {is_active: {_eq: true}}, limit: 1) {
        last_four_digits
      }
    }
    user {
      username
    }
  }
  }
`;
export const TAB_MANAGEMENT_REPORT_COUNT = gql`
  query orders_aggregate(
    $where: orders_bool_exp!
  ) {
    total: orders_aggregate(where: $where) {
      aggregate {
        count
        __typename
      }
      __typename
    }
  }
`;
